export default __webpack_public_path__ + "static/media/france.b51b27b9.webp";